// RECORD COUNT API
import Request from '../base'
export default {
  countOrg (options) {
    return Request.post('/ebercount/countapi/record/count/org', options)
  },
  firstPosition (options) {
    return Request.post('/ebercount/countapi/record/count/firstPosition', options)
  },
  countPosition (options) {
    return Request.post('/ebercount/countapi/record/count/position', options)
  },
  countFollowup (options) {
    return Request.post('/ebercount/countapi/record/count/followup', options)
  },
  countOrgGroup (options) {
    return Request.post('/ebercount/countapi/record/count/orggroup', options)
  },
  orgdays (options) {
    return Request.post('/ebercount/countapi/record/count/orgdays', options)
  },
  workload(options) {
    return Request.post('/ebercount/countapi/record/count/workload', options)
  }
}
